import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import {
  Button, Col, Row, Spin,
} from 'antd';
import EmptyComponent from 'components/Empty';
import React, { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import ModifierModal from '../ModifierModal';
import SearchItemInput from '../../components/SearchItemInput';
import { ModalMode } from '../../constants';
import { ModifierContext } from '../../context';

function ModifierActions() {
  const { id: merchantId } = useParams();
  const {
    loading, modifiers, setSearchTerm, posHubIntegrated,
  } = useContext(ModifierContext);
  const [mode, setMode] = useState(ModalMode.CLOSED);

  const posHubMenusPath = `/console/restaurants/${merchantId}/pos/menus`;

  if (!modifiers.length) {
    return loading ? <Spin indicator={<LoadingOutlined style={{ fontSize: 36, marginTop: 24 }} spin />} />
      : (
        <>
          {posHubIntegrated ? (
            <EmptyComponent
              title="Modifiers are managed via POS"
              description="Options and modifiers sync from your POS. Use the POS integration console to change catalog and menu structure."
              primaryAction={(
                <Button type="primary" href={posHubMenusPath}>
                  Open POS menus
                </Button>
              )}
            />
          ) : (
            <EmptyComponent
              title="This merchant does not have any modifier!"
              primaryAction={(
                <Button icon={<PlusOutlined />} onClick={() => setMode(ModalMode.NEW)} type="primary">
                  Add modifier
                </Button>
              )}
            />
          )}
          {!posHubIntegrated && <ModifierModal mode={mode} setMode={setMode} />}
        </>
      );
  }
  return (
    <>
      <Row style={{ alignItems: 'center', gap: 8, justifyContent: 'space-between' }}>
        <Col xs={24} md={14} lg={12} xl={8}>
          <SearchItemInput placeholder="Search for a modifier" setSearchTerm={setSearchTerm} />
        </Col>
        {!posHubIntegrated && (
          <Col xs={24} md={4} lg={4} xl={3}>
            <Button icon={<PlusOutlined />} onClick={() => setMode(ModalMode.NEW)}>
              Add modifier
            </Button>
          </Col>
        )}
      </Row>

      {!posHubIntegrated && <ModifierModal mode={mode} setMode={setMode} />}
    </>
  );
}

export default ModifierActions;
